import React from 'react';

const FEATURES = [
  {
    icon: '💬',
    title: '900+ real conversations',
    body: 'Practice full dialogues for real situations: food, travel, doctors, banks, salons, work, customer service, and more.',
  },
  {
    icon: '🎧',
    title: 'Listen before you speak',
    body: 'Hear each line naturally, then repeat it until it feels easy to say.',
  },
  {
    icon: '🎭',
    title: 'Role play real situations',
    body: 'Hide your line, say it out loud, then reveal the natural answer.',
  },
  {
    icon: '🔁',
    title: 'Say it more than one way',
    body: 'Learn natural alternatives, so you are not stuck with only one phrase.',
  },
  {
    icon: '⭐',
    title: 'Save useful lines',
    body: 'Save conversations, lines, and quizzes to review right before a real situation.',
  },
  {
    icon: '🔥',
    title: 'Build a speaking habit',
    body: 'Practice one short conversation or three useful lines a day.',
  },
];

export default function Features() {
  return (
    <section className="section" id="features">
      <h2 className="section__title">Everything you need to stop freezing</h2>
      <div className="feature-grid">
        {FEATURES.map((f) => (
          <div className="feature-card" key={f.title}>
            <div className="feature-card__icon" aria-hidden="true">{f.icon}</div>
            <h3>{f.title}</h3>
            <p>{f.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
